module.exports = __webpack_public_path__ + "img/succes_info_icon.0243592f.svg";